import React from 'react';
import ReactDOM from 'react-dom/client';
import ReactGA from 'react-ga4';
import { BrowserRouter as Router } from 'react-router-dom'; // Import BrowserRouter
import MPEGMode from 'lamejs/src/js/MPEGMode';
import Lame from 'lamejs/src/js/Lame';
import BitStream from 'lamejs/src/js/BitStream';

import './index.css';
import Main from './Main';
import reportWebVitals from './reportWebVitals';
import './i18n';
import Layout from './Layout';
import Analytics from './Analytics';

ReactGA.initialize(process.env.REACT_APP_GA_MEASUREMENT_ID);

// PATCH console.error globally
if (typeof window !== 'undefined' && window.newrelic) {
  const originalConsoleError = console.error;

  console.error = function (...args) {
    originalConsoleError.apply(console, args);

    const message = args.map(arg => {
      if (arg instanceof Error) return arg.message;
      if (typeof arg === 'object') return JSON.stringify(arg);
      return String(arg);
    }).join(' ');

    window.newrelic.noticeError(new Error(message));
  };

  // Global error handler
  window.addEventListener('error', (event) => {
    if (event?.error) {
      window.newrelic.noticeError(event.error);
    } else if (event?.message) {
      window.newrelic.noticeError(new Error(event.message));
    }
  });

  // Unhandled Promise rejection
  window.addEventListener('unhandledrejection', (event) => {
    const error = event.reason instanceof Error ? event.reason : new Error(String(event.reason));
    window.newrelic.noticeError(error);
  });
}

if (typeof window !== 'undefined') {
  window.MPEGMode = MPEGMode;
  window.Lame = Lame;
  window.BitStream = BitStream;
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
    <Router
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true,
      }}
    >  {/* Wrap Main in Router */}
      <Analytics />
      <Layout>
       <Main />
      </Layout>
    </Router>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
